export default class CreateActivityCtrl {

  constructor ($scope, WorkPlanSrv, $mdDialog, $stateParams, $cookies, GlobalConfig, GlobalSrv) {
    var createActivityVm = this
    const currentUser = JSON.parse($cookies.get('currentUser'))
    createActivityVm.nameActivityModal = ""
    createActivityVm.hrefActivityModal = "Añadir "
    createActivityVm.editOrCreated = "Creación exitosa"
    createActivityVm.createOrEdit = "Añadir"
    createActivityVm.idWorkPlan = currentUser.workplanId
    createActivityVm.idTeacher = currentUser.teacherId
    createActivityVm.comboActivities = []
    createActivityVm.activityItem = []
    createActivityVm.itemActivityRequired = []
    createActivityVm.cleanForm = cleanForm
    createActivityVm.cleanRangeType = cleanRangeType
    createActivityVm.isEditing = ($stateParams.activityId) ? true : false
    createActivityVm.close = close
    createActivityVm.hours = 0
    createActivityVm.isSaveButtonDisabled = false
    createActivityVm.isFeedback = currentUser.isFeedback
    createActivityVm.hasError = (input) => {
      if (input && input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    createActivityVm.showErrorMessages = (input) => {
      return input.$dirty || input.$touched
    }

    createActivityVm.validateForm = (form) => {
      return form.$invalid
    }

    activate()

    function activate () {
      if(createActivityVm.isEditing) {
        createActivityVm.createOrEdit = "Editar "
        createActivityVm.editOrCreated = "Edición exitosa"
      }

      // Combo type of activity
      let requestHeader = {
        listTypeId:  GlobalConfig.typeListId.teaching, 
        listId: GlobalConfig.listId.teachingOtherActivities
      }
      WorkPlanSrv.getActivitiesCombo.getList(requestHeader).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          createActivityVm.comboActivities = dataReturn.data
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {
        console.log(data)
      })

      if (createActivityVm.isEditing) {
        return editActivitySrv().then(() => {})
      }
    }

    function isAllActivityItemRequired(){
      let header = {
        teacherId: currentUser.teacherId,
        workplanId: currentUser.workplanId,
        listId: GlobalConfig.listId.teachingOtherActivities
      }

      WorkPlanSrv.getItemRequiredOtherActivities.getList(header).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          createActivityVm.itemActivityRequired = dataReturn.otherActivities
          if(createActivityVm.itemActivityRequired.length > 0)
            showModalItemRequired()
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {
        console.log(data)
      })
    }

    function showModalItemRequired() {
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
          $scope.itemRequired = createActivityVm.itemActivityRequired
          $scope.activityModal = createActivityVm.hrefActivityModal
          $scope.close = function() {
            $mdDialog.hide()
          }
        }],
        template: require('./activityItemRequiredModal.html'),
        clickOutsideToClose:false
      });
    }

    createActivityVm.addActivity = (sw, isExecution) => {
      createActivityVm.isSaveButtonDisabled = true
      createActivityVm.hrefActivityModal = sw
      let origin = 1
      if(isExecution){
        origin = GlobalConfig.activityTypeId.originActivityExecution
      }
      createJson(origin)
    }

    function createJson (origin) {
      var assignment = {
        otherActivityCode: $stateParams.activityId,
        idTeacher: createActivityVm.idTeacher,
        idWorkPlan: createActivityVm.idWorkPlan,
        activityTypeCode: createActivityVm.typeActivity,
        otherActivityHoursPlaned: createActivityVm.hours,
        otherActivityName: createActivityVm.nameActivity,
        otherActivityDetail: createActivityVm.detail,
        origin: origin,
        isFeedbackActivity: createActivityVm.isFeedback
      }

      if (createActivityVm.isEditing) {
        // add activity
        WorkPlanSrv.updateActivityItem.update(assignment).$promise.then(function (dataReturn) {
          if (dataReturn.status) {
            createActivityModal()
          } else {
            createActivityVm.isSaveButtonDisabled = false
            console.log('Comunications problem with the server')
          }
        }, function (data) {
          createActivityVm.isSaveButtonDisabled = false
          console.log(data)
        })
      } else {
        // add activity
        WorkPlanSrv.addActivityItem.add(assignment).$promise.then(function (dataReturn) {
          if (dataReturn.status) {        
            createActivityModal()            
          } else {
            createActivityVm.isSaveButtonDisabled = false
            console.log('Comunications problem with the server')
          }
        }, function (data) {
          createActivityVm.isSaveButtonDisabled = false
          console.log(data)
        })
      }

    }

    function cleanForm(form) {
      createActivityVm.nameActivityModal = createActivityVm.nameActivity
      createActivityVm.typeActivity = 0
      createActivityVm.hours = 0
      createActivityVm.nameActivity = undefined
      createActivityVm.detail = undefined
      form.$setPristine()
      form.$setUntouched()
    }

    function createActivityModal () {
      let texts = GlobalConfig.appTexts
      let activityName = createActivityVm.nameActivityModal
      let hrefActivity = createActivityVm.hrefActivityModal
      let actionEditOrCreate = texts.saved
      let sucsessAction   = texts.createDialog
      if (createActivityVm.isEditing) {
        actionEditOrCreate = texts.modified
        sucsessAction   = texts.editDialog
      } 
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', '$state', function ($scope, $mdDialog, $state) {
          let ctrlModal = this
          ctrlModal.sucsessAction = sucsessAction
          ctrlModal.activityModal = hrefActivity
          ctrlModal.actionEditOrCreateModal = actionEditOrCreate
          ctrlModal.nameActivityModal = activityName
          ctrlModal.close = function () {
            isAllActivityItemRequired()
            $mdDialog.hide()
            $state.reload()
          }
        }],
        controllerAs: 'ctrlModal',
        template: require('./createActivityModal.html'),
        clickOutsideToClose: false
      })
    }

    function editActivity () {
      createActivityVm.typeActivity = createActivityVm.activityItem[0].activityTypeCode
      createActivityVm.hours = createActivityVm.activityItem[0].otherActivityHoursPlaned
      createActivityVm.nameActivity = createActivityVm.activityItem[0].otherActivityName
      createActivityVm.detail = createActivityVm.activityItem[0].otherActivityDetail
    }

    function editActivitySrv () {
      // Activity Item
      return WorkPlanSrv.getActivityItem.get({otherActivityCode: $stateParams.activityId})
      .$promise.then(function (dataReturn) {
        if (dataReturn.status === true) {
          createActivityVm.activityItem = dataReturn.data
          editActivity()
        } else {
          createActivityVm.activityItem = []
        }
      }, function (data) {
        console.log(data)
      })
    }

    function close (){
      $mdDialog.hide()
    }

    function cleanRangeType(){
      if(parseInt(createActivityVm.rangeType) == GlobalConfig.periods.rangeType){
        createActivityVm.startDate = null
        createActivityVm.endDate = null
      }else{
        createActivityVm.periodsArray = []
        createActivityVm.selectedTypePeriod = null
      }
    }

    /*
    var inputs = "textarea[maxlength]";
    $(document).on('keyup', "[maxlength]", function (e) {
        var este = $(this),
            maxlength = este.attr('maxlength'),
            maxlengthint = parseInt(maxlength),
            textoActual = este.val(),
            currentCharacters = este.val().length,
            remainingCharacters = maxlengthint - currentCharacters,
            espan = este.prev('div').find('span'); 
            console.log('-----------------------')
            console.log(textoActual)
            console.log(maxlengthint)     
            console.log(currentCharacters) 
            console.log(remainingCharacters) 
            console.log(espan)
            // Detectamos si es IE9 y si hemos llegado al final, convertir el -1 en 0 - bug ie9 porq. no coge directamente el atributo 'maxlength' de HTML5
            espan.html(currentCharacters);
            if (!!maxlength) {
                var texto = este.val(); 
                if (texto.length >= maxlength) {
                    este.removeClass().addClass('borderojo');
                    este.val(texto.substring(0, maxlength));
                    e.preventDefault();
                }
                else if (texto.length < maxlength) {
                    este.removeClass().addClass("bordegris");
                }   
            }   
        });
    */
  }

}

CreateActivityCtrl.$inject = ['$scope', 'WorkPlanSrv', '$mdDialog', '$stateParams', '$cookies', 'GlobalConfig', 'GlobalSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/teaching/activities/createActivity/createActivityCtrl.js